import type { Question } from "../data/assessmentData";
import en from "./en";
import fr from "./fr";
import nl from "./nl";

export type Locale = "en" | "fr" | "nl";

type Cat = "bas" | "mid" | "haut";

export interface FeedbackBundle {
  pillarFeedbacks: Record<number, Record<Cat, string>>;
  crossP2: Record<Cat, Record<Cat, string>>;
  crossP3Uniforme: Record<Cat, string>;
  crossP3EnRetrait: Record<"strategie" | "marque" | "contenu", string>;
  crossP3EnAvance: Record<"strategie" | "marque" | "contenu", string>;
}

export interface LocaleStrings {
  ui: Record<string, string>;
  questions: Question[];
  feedback: FeedbackBundle;
  radarAxisLabels: readonly [string, string, string, string];
}

const locales: Record<Locale, LocaleStrings> = { en, fr, nl };

export function getLocale(locale: Locale): LocaleStrings {
  return locales[locale];
}

export function getAssessmentData(locale: Locale): Question[] {
  return locales[locale].questions;
}

export function getFeedbackBundle(locale: Locale): FeedbackBundle {
  return locales[locale].feedback;
}
